import React, { useContext } from 'react';
import { TenantEnv } from '../types';

const GlobalDataContext = React.createContext<TenantEnv>(null);

export const GlobalDataProvider = GlobalDataContext.Provider;

export function useGlobalData(): TenantEnv {
  const context = useContext(GlobalDataContext);
  if (!context) {
    throw new Error(
      'useGlobalData must be inside a GlobalDataProvider with a state value',
    );
  }
  return context;
}

// for backward compatible
export const useTenantConfig = () => {
  return useGlobalData();
};
